<template>
  <v-container>
    <v-alert :type="alertType" v-model="alertActive" dismissible outline>
      {{ alertMessage }}
    </v-alert>
    <v-dialog v-model="icoDialog" persistent max-width="590">
      <v-card>
        <v-card-title class="indigo white--text headline">{{
          $t('inconsistent_ico')
        }}</v-card-title>
        <v-card-text>{{ icoText }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="closeIco()">{{
            $t('back')
          }}</v-btn>
          <v-btn
            v-if="allowSetDealer"
            color="green darken-1"
            flat
            @click="setAsDealer"
            >{{ $t('set_as_dealer') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar flat color="primary">
      <v-toolbar-title class="white--text">{{ $t('dealers') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('search')"
        single-line
        hide-details
        solo
        clearable
      ></v-text-field>
      <v-dialog v-model="dialog" max-width="580px">
        <v-btn color="primary-darken5" dark class="mb-2" slot="activator">{{
          $t('new_dealer')
        }}</v-btn>
        <v-card class="mx-auto" max-width="600" fill-height>
          <v-card-title
            class="primary white--text headline font-weight-regular justify-space-between"
          >
            <span>{{ formTitle }}</span>
          </v-card-title>

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-text>
              <v-layout xs12 md12 lg12 column>
                <v-text-field
                  xs12
                  md12
                  lg12
                  :label="$t('email')"
                  v-model="user.Email"
                  :rules="emailRules"
                  required
                ></v-text-field>
                <div v-if="editedIndex === -1">
                  <v-text-field
                    xs12
                    :label="$t('password')"
                    :counter="0"
                    :rules="pwdRules"
                    v-model="user.UserPassword"
                    :append-icon="show ? 'visibility' : 'visibility_off'"
                    :type="show ? 'text' : 'password'"
                    :hint="$t('at_least_8_characters')"
                    @click:append="show = !show"
                    @blur="$refs.form.validate()"
                    @change="$refs.form.validate()"
                  ></v-text-field>
                  <v-text-field
                    xs12
                    :label="$t('confirm_password')"
                    v-model="user.match"
                    :rules="rpPwdRules"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                    :hint="$t('at_least_8_characters')"
                    @click:append="show1 = !show1"
                  ></v-text-field>

                  <v-alert type="error" v-model="alert" dismissible outline>
                    {{ errmessage }}
                  </v-alert>

                  <v-text-field
                    ref="ic"
                    :label="$t('ic')"
                    v-model="user.ICO"
                    :rules="icRules"
                    @blur="checkIc"
                    required
                  ></v-text-field>

                  <v-btn primary small @click="getAres">ares</v-btn>
                </div>
                <v-text-field
                  :label="$t('name')"
                  v-model="user.Name"
                  :rules="nameRules"
                  required
                ></v-text-field>

                <v-text-field
                  xs4
                  :label="$t('dic')"
                  v-model="user.DIC"
                  :rules="dicRules"
                ></v-text-field>

                <v-text-field
                  :label="$t('fname')"
                  v-model="user.UserFirstName"
                ></v-text-field>

                <v-text-field
                  :label="$t('surname')"
                  v-model="user.UserLastName"
                ></v-text-field>

                <v-text-field
                  :label="$t('street')"
                  v-model="user.Street"
                ></v-text-field>

                <v-text-field
                  :label="$t('house_number')"
                  v-model="user.DescNumber"
                  :rules="hounoRules"
                  required
                ></v-text-field>
                <v-text-field
                  :label="$t('house_ref')"
                  v-model="user.RefNumber"
                  :rules="houcoRules"
                  required
                ></v-text-field>

                <v-text-field
                  :label="$t('city')"
                  v-model="user.City"
                  :rules="cityRules"
                  required
                ></v-text-field>

                <v-text-field
                  :label="$t('psc')"
                  v-model="user.ZipCode"
                  :rules="pscRules"
                  required
                ></v-text-field>

                <v-text-field
                  :label="$t('phone')"
                  v-model="user.Phone"
                  required
                ></v-text-field>
              </v-layout>
            </v-card-text>
          </v-form>
          <v-card-actions>
            <v-btn flat @click="close()">{{ $t('back') }}</v-btn>
            <v-spacer></v-spacer>

            <v-btn color="primary" depressed @click="save()">{{
              $t('save')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-right">{{ props.item.ICO }}</td>
        <td class="text-xs-right">{{ props.item.DIC }}</td>
        <td class>{{ props.item.Name }}</td>
        <td class>{{ props.item.UserFirstName }}</td>
        <td class>{{ props.item.UserLastName }}</td>
        <td class>{{ props.item.Street }}</td>
        <td class>{{ props.item.DescNumber }}</td>
        <td class>{{ props.item.RefNumber }}</td>
        <td class>{{ props.item.City }}</td>
        <td class>{{ props.item.ZipCode }}</td>
        <td class>{{ props.item.Email }}</td>
        <td class>{{ props.item.Phone }}</td>
        <!-- <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
            <v-btn icon class="mx-0" @click="deleteItem(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>-->
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          {{ $t('your_search {search}', { search: search }) }}
        </v-alert>
      </template>

      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import validatation from 'validate.js'
export default {
  data() {
    return {
      alertType: 'success',
      alertActive: false,
      alertMessage: '',
      dialog: false,
      icoDialog: false,
      icoText: '',
      allowSetDealer: false,
      valid: false,
      alert: false,
      show: false,
      show1: false,
      dealer_id: null,
      errmessage: '',
      search: '',
      match: '',
      headers: [
        { text: this.$t('ic'), value: 'ICO' },
        { text: this.$t('dic'), value: 'DIC' },
        { text: this.$t('name'), value: 'Name' },
        { text: this.$t('fname'), value: 'UserFirstName' },
        { text: this.$t('surname'), value: 'UserLastName' },
        { text: this.$t('street'), value: 'Street' },
        { text: this.$t('house_number'), value: 'DescNumber' },
        { text: this.$t('house_ref'), value: 'RefNumber' },
        { text: this.$t('city'), value: 'City' },
        { text: this.$t('psc'), value: 'ZipCode' },
        { text: this.$t('email'), value: 'Email' },
        { text: this.$t('phone'), value: 'Phone' }
        // { text: this.$t('actions'), value: 'actions' }
      ],
      items: [],
      user: {
        Id: 0,
        ICO: '',
        DIC: '',
        Name: '',
        Street: '',
        DescNumber: '',
        RefNumber: '',
        City: '',
        ZipCode: '',
        Email: '',
        Phone: '',
        IsVatPayer: false,
        UserFirstName: '',
        UserLastName: '',
        IsDealer: true,
        UserLevel: 1,
        UserPassword: '',
        LanguageName: 'CZ',
        CountryName: 'CZ',
        Type: 'person',
        match: ''
      },
      constraints: {
        from: {
          email: true
        }
      },
      emailRules: [
        v => !!v || this.$t('email_is_required'),
        v =>
          !validatation({ from: v }, this.constraints) ||
          this.$t('email_must_be_valid') ///.+@.+/.test(v)
      ],
      pwdRules: [
        v => !!v || this.$t('passwd_is_required'),
        v => {
          if (v.length >= 8) {
            const hasUpperCase = /[A-Z]/.test(v)
            const hasLowerCase = /[a-z]/.test(v)
            const hasNumbers = /\d/.test(v)
            const hasNonalphas = /\W/.test(v)
            if (hasUpperCase + hasLowerCase + hasNumbers + hasNonalphas < 3) {
              return this.$t('passwd_must_contains')
            } else {
              return true
            }
          } else {
            return this.$t('passwd_is_short')
          }
        }
      ],
      rpPwdRules: [
        v => !!v || this.$t('passwd_is_required'),
        v => v === this.user.UserPassword || this.$t('password_do_not_match')
      ],
      icRules: [
        v => !!v || this.$t('ico_is_required'),
        v => /\d/.test(v) || this.$t('only_digits'),
        v => !(v.length > 8) || this.$t('field_is_too_long')
      ],
      dicRules: [],
      nameRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 99) || this.$t('field_is_too_long')
      ],
      streetRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 99) || this.$t('field_is_too_long')
      ],
      hounoRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 10) || this.$t('field_is_too_long'),
        v => /\d/.test(v) || this.$t('only_digits')
      ],
      houcoRules: [v => !(v.length > 10) || this.$t('field_is_too_long')],
      cityRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 99) || this.$t('field_is_too_long')
      ],
      pscRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 6) || this.$t('field_is_too_long'),
        v => /\d/.test(v) || this.$t('only_digits')
      ],
      editedIndex: -1,
      defaultItem: {
        ICO: '',
        DIC: '',
        Name: '',
        Street: '',
        City: '',
        ZipCode: '',
        Email: '',
        Phone: '',
        IsVatPayer: false,
        UserFirstName: '',
        UserLastName: '',
        IsDealer: true,
        UserLevel: 1,
        DescNumber: '',
        RefNumber: '',
        UserPassword: '',
        LanguageName: 'CZ',
        CountryName: 'CZ',
        Type: 'person',
        match: ''
      }
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('new_dealer')
        : this.$t('edit_dealer')
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    icoDialog(val) {
      val || this.closeIco()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      this.getDealers()
    },
    closeIco() {
      this.user.ICO = ''
      this.icoDialog = false
    },
    async getDealers() {
      this.$root.$loader(true)
      try {
        let r = await this.axios.get(
          this.$providerURL + `/Api/Partner/GetDealerList`
        )
        this.items = r.data.Items
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    async checkIc() {
      if (!this.user.ICO) {
        return
      }
      this.$root.$loader(true)
      try {
        let res = await this.axios.get(
          this.$providerURL + `/Api/Partner/VerifyICO?ICO=${this.user.ICO}`
        )
        if (res.status === 200) {
          this.dealer_id = res.data
          this.icoText = this.$t('dealer_set')
          this.allowSetDealer = true
          this.icoDialog = true
        }
        return true
      } catch (error) {
        if (error.response.data.Code === 205) {
          this.allowSetDealer = false
          this.icoText = this.$t('dealer_exist')
          this.icoDialog = true
        } else if (error.response.data.Code === 206) {
          this.allowSetDealer = false
          this.icoText = this.$t('dealer_wait')
          this.icoDialog = true
        } else if (error.response.data.Code === 207) {
          this.icoText = this.$t('dealer_set')
          this.allowSetDealer = true
          this.icoDialog = true
        }
        return false
      } finally {
        this.$root.$loader(false)
      }
    },

    async getAres() {
      if (!this.user.ICO) {
        this.errmessage = this.$t('ic_msg')
        this.alert = true
        setTimeout(() => {
          this.alert = false
        }, 5000)
        return
      }
      this.$root.$loader(true)
      try {
        let res = await this.axios.get(`/api/ares/ico/${this.user.ICO}/`)
        this.user.ICO = res.data.ic
        this.user.DIC = res.data.dic
        this.user.Name = res.data.name
        this.user.Street = res.data.street
        this.user.DescNumber = res.data.house_no
        this.user.RefNumber = res.data.house_co
        this.user.IsVatPayer = res.data.dph_reg || false
        this.user.Type = res.data.type
        this.user.City = res.data.city
        this.user.ZipCode = res.data.psc
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item)
      this.user = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.items.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.items.splice(index, 1)
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.user = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 200)
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.user)
        this.changeProfile()
      } else {
        this.registerUser()
        this.items.push(this.user)
      }
      this.close()
    },
    async setAsDealer() {
      this.$root.$loader(true)
      try {
        await this.axios.get(
          this.$providerURL +
            `/Api/Partner/SetAsDealer?collisionPartnerId=${this.dealer_id}`
        )

        this.closeIco()
        this.close()
        this.alertMessage = this.$t('dealer_set_ok')
        this.alertActive = true
        setTimeout(() => {
          this.alertActive = false
          this.dealer_id = null
        }, 5000)
        this.getDealers()
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    async registerUser() {
      let id = null
      this.$root.$loader(true)
      try {
        id = await this.$http.get(this.$providerURL + '/Api/Access/GetNewId')
        this.user.RegistrationCode = id.data
        this.user.RegistrationUrl =
          this.$uiURL + `/finish_registration?registrationCode=${id.data}`
        let resp = await this.$http.post(
          this.$providerURL + '/Api/Partner/RegisterPartner',
          this.user
        )
        if (resp.status === 200) {
          this.close()
          this.alertMessage = this.$t('dealer_ok')
          this.alertActive = true
          setTimeout(() => {
            this.alertActive = false
          }, 5000)
        }
      } catch (error) {
        this.user.ic = ''
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    async changeProfile() {
      this.$root.$loader(true)

      try {
        let resp = await this.$http.post(
          this.$providerURL + '/Api/Partner/UpdatePartner',
          this.user
        )
        if (resp.status === 200) {
          this.alertMessage = this.$t('dealer_ok')
          this.alertActive = true
          setTimeout(() => {
            this.alertActive = false
          }, 5000)
        }
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    }
  }
}
</script>
